import React, { useContext, useState } from 'react';
import { MediaBlockView, MediaBlockViewProps } from './MediaBlock.view';
import { PostEditorContext } from '../states/PostEditorProvider';
import { PostEditorMediaRemoveAction } from '../states/PostEditorActions';

export type MediaBlockControllerProps = {
  formInstance: MediaBlockViewProps['formInstance'];
};

export const MediaBlockController = (props: MediaBlockControllerProps): JSX.Element => {
  // Put All your methods and logic here
  const { formInstance } = props;
  const { dispatch } = useContext(PostEditorContext);
  const [showSelectionModal, setShowSelectionModal] = useState<boolean>(false);

  const onRemoveMedia: MediaBlockViewProps['onRemoveMedia'] = (media, postGroupIndex, customizeIndex) => {
    const payload: PostEditorMediaRemoveAction['payload'] = {
      postGroupIndex,
      customizeIndex,
      id: media.id,
      type: media.type
    };
    dispatch({ type: 'mediaRemove', payload });
  };

  const viewProps: MediaBlockViewProps = {
    formInstance,
    showSelectionModal,
    setShowSelectionModal,
    onRemoveMedia
  };
  return <MediaBlockView {...viewProps} />;
};
